import React from "react";
import { useContractTracking } from "../contexts/ContractTrackingContext";

interface TrackButtonProps {
    symbol: string;
    strike: number;
    expiry: string;
    optionType: string;
    lastPrice?: number;
    lastVolume?: number;
    lastOI?: number;
    lastBid?: number;
    lastAsk?: number;
    lastDelta?: number;
    lastGamma?: number;
    lastTheta?: number;
    lastVega?: number;
    lastIV?: number;
    lastPremium?: number;
}

const TrackButton: React.FC<TrackButtonProps> = ({
    symbol,
    strike,
    expiry,
    optionType,
    lastPrice,
    lastVolume,
    lastOI,
    lastBid,
    lastAsk,
    lastDelta,
    lastGamma,
    lastTheta,
    lastVega,
    lastIV,
    lastPremium,
}) => {
    const { isTracked, addContract, removeContract } = useContractTracking();
    const tracked = isTracked(symbol, strike, expiry, optionType);

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (tracked) {
            const id = `${symbol.toUpperCase()}|${strike}|${expiry}|${optionType.toUpperCase()}`;
            removeContract(id);
        } else {
            addContract({
                symbol: symbol.toUpperCase(),
                strike,
                expiry,
                optionType: optionType as "C" | "P",
                snapshotPrice: lastPrice,
                snapshotVolume: lastVolume,
                snapshotOI: lastOI,
                snapshotBid: lastBid,
                snapshotAsk: lastAsk,
                snapshotDelta: lastDelta,
                snapshotGamma: lastGamma,
                snapshotTheta: lastTheta,
                snapshotVega: lastVega,
                snapshotIV: lastIV,
                snapshotPremium: lastPremium,
                lastPrice,
                lastVolume,
                lastOI,
                lastBid,
                lastAsk,
                lastDelta,
                lastGamma,
                lastTheta,
                lastVega,
                lastIV,
                lastPremium,
            });
        }
    };

    return (
        <button
            onClick={handleClick}
            title={tracked ? "Remove from watchlist" : "Add to watchlist"}
            style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "14px",
                lineHeight: 1,
                padding: "2px 4px",
                borderRadius: 4,
                opacity: tracked ? 1 : 0.4,
                filter: tracked ? "none" : "grayscale(100%)",
                transition: "opacity var(--dur-micro) var(--ease), filter var(--dur-micro) var(--ease)",
            }}
            onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.opacity = "1";
                (e.currentTarget as HTMLElement).style.filter = "none";
            }}
            onMouseLeave={(e) => {
                if (!tracked) {
                    (e.currentTarget as HTMLElement).style.opacity = "0.4";
                    (e.currentTarget as HTMLElement).style.filter =
                        "grayscale(100%)";
                }
            }}
        >
            {tracked ? "⭐" : "☆"}
        </button>
    );
};

export default TrackButton;
